import React, { useEffect, useState } from "react";
import { getTotalTracksCount } from "../../services/trackService";
import { GetTotalTracksCountResponse } from "../../proto/api_pb";
import { TotalTrackCountProps } from "./types";

const TotalTracksCount: React.FC<TotalTrackCountProps> = ({
    getValidAccessToken,
    userId,
    enterpriseId,
    updateCount,
    setUpdateCount,
}) => {
    const [trackCount, setTrackCount] = useState<number | null>(null);

    useEffect(() => {
        const getCount = async () => {
            if (!enterpriseId || !userId) return;
            try {
                const token = await getValidAccessToken();
                const response = await getTotalTracksCount(token, userId, enterpriseId);
                if (response instanceof GetTotalTracksCountResponse) {
                    setTrackCount(response.getTracksCount());
                } else {
                    setTrackCount(null);
                }
            } catch (error) {
                console.error("Error fetching track count:", error);
                setTrackCount(null);
            }
            if (updateCount && setUpdateCount) {
                setUpdateCount(false);
            }
        };

        getCount();
    }, [enterpriseId, userId, updateCount, setUpdateCount, getValidAccessToken]);

    if (trackCount === null) return null;

    return (
        <span style={{ fontSize: "1.5rem", fontWeight: "normal" }}>
            ({trackCount} Tracks)
        </span>
    );
};

export default TotalTracksCount;
